<template>
  <div class="community-page">
    <NavBar
      :title-config="{ title: $t('app_community'), fixed: true, leftArrow: false }"
      :show-title="false"
      @rightClick="rightClick"
      :feishuShow="true"
      :weixinShow="true"
      :tudoShow="true"
      :sands-talk-native="isSandsTalkFlutterApp"
      :sands-talk-ms-flutter-app="isSandsTalkMSFlutterApp"
      :sands-talk-ph-outfield-app="isSandsTalkPhOutfieldApp"
      :wisdom-rabbit-app="isWisdomRabbitApp"
      :branch-manager-app="isBranchManagerApp"
    >
      <template v-slot:right>
        <i class="iconfont icon-icon_shouye_sousuo_w"></i>
      </template>
    </NavBar>
    <PullToRefresh v-model="refreshing" @refresh="onRefresh">
      <div class="content">
        <List
          v-model:loading="loading"
          :finished="finished"
          @load="onLoad"
          :finished-text="isShowMore ? $t('in_the_end') : ''"
        >
          <Banner v-if="bannerList.length > 0" :bannerList="bannerList"></Banner>
          <Column v-if="boardsData.records && boardsData.records.length > 0" :boardsData="boardsData"></Column>
          <TopArea v-if="topData.length > 0" :topData="topData"></TopArea>
          <Article
            @showPreview="showPreview"
            :top="44"
            :articleData="articleData"
            :activeType="activeType"
            :type="1"
            @handleActive="handleActive"
            :listLoading="listLoading"
            :page="1"
          ></Article>
          <template #loading>
            <Loading type="spinner" />
          </template>
        </List>
      </div>
    </PullToRefresh>
    <BackTop></BackTop>
    <AddBtn></AddBtn>
    <ImgPreview
      :imageList="imageList"
      :previewIndex="previewIndex"
      :previewShow="previewShow"
      @closePreview="handleClose"
    ></ImgPreview>
  </div>
</template>

<script lang="ts" setup>
import NavBar from '@/components/NavBar.vue'
import Column from './components/Column.vue'
import TopArea from './components/TopArea.vue'
import Article from './components/Article.vue'
import Banner from './components/Banner.vue'
import BackTop from '@/components/BackTop.vue'
import AddBtn from './components/AddBtn.vue'
import ImgPreview from '@/components/ImgPreview.vue'
import { onActivated, onMounted, ref, watch } from 'vue'
import { getCommunityBoardContentList, getCommunityHomeData } from '@/api/requests/CommunityRequests'
import { useRouter, useRoute } from 'vue-router'
import { Attachment } from '@/api/Models/Attachment'
import { Record } from '@/api/Models/CommunityBoardContentList'
import { List, Loading } from 'vant'
import PullToRefresh from '@/components/PullToRefresh.vue'
import { CommunityBanners } from '@/api/Models/CommunityBanners'
import { useComponentStore } from '@/stores/components'
import { storeToRefs } from 'pinia'
import { ColumnBoardPage, TopContent } from '@/api/Models/CommunityHomeData'
import { isSandsTalkFlutterApp } from '@/utils/sandsTalkFlutter'
import { isSandsTalkMSFlutterApp } from '@/utils/sandsTalkMSFlutter'
import { isSandsTalkPhOutfieldApp } from '@/utils/sandsTalkPhOutfiled'
import { isWisdomRabbitApp } from '@/utils/sandsTalkSmartRabbit'
import { isBranchManagerApp } from '@/utils/sandsTalkBranchManager'

const loading = ref(false)
const finished = ref(true)
const refreshing = ref(false)
const sortType = ref<string>('1')
const current = ref(2)
const articleData = ref([] as Record[])
const activeType = ref<number>(0) // tab切换
const listLoading = ref(true)
const total = ref<number>(0)
const pageSize = ref<number>(20)
const isShowMore = ref<boolean>(false)
const onLoad = async () => {
  if (refreshing.value) {
    articleData.value = []
    refreshing.value = false
  }
  const { code, data } = await getCommunityBoardContentList({
    current: current.value,
    size: pageSize.value,
    sortType: sortType.value,
    ...(activeType.value && {
      type: activeType.value
    })
  })
  loading.value = false
  if (code === 1) {
    listLoading.value = true
    total.value = data.total
    if (!data.records || data.records.length === 0) {
      finished.value = true
    }
    if (current.value === 1) {
      articleData.value = data.records
    } else {
      articleData.value.push(...data.records)
    }
    if (current.value >= Math.ceil(total.value) / pageSize.value) {
      finished.value = true
    } else {
      current.value++
      finished.value = false
    }
    if (pageSize.value < total.value) {
      isShowMore.value = true
    }
  } else {
    finished.value = true
  }
}
const onRefresh = (isLoading: boolean) => {
  current.value = 1
  fetchData(1, isLoading)
  onLoad()
}
const router = useRouter()
const rightClick = () => {
  const componentsStore = useComponentStore()
  const { includeComponents } = storeToRefs(componentsStore)
  const filteredArr = includeComponents.value.filter((element) => element !== 'communitySearchPage')
  componentsStore.setIncludeComponents(filteredArr)
  router.push({ path: '/communitySearchPage', query: { type: 1 } })
}
// 图片预览
const previewShow = ref(false)
const previewIndex = ref(0)
const imageList = ref([] as string[])
const showPreview = (data: { attachments: Attachment[]; index: number }) => {
  imageList.value = data?.attachments.map((item) => item.previewUrl) as string[]
  previewShow.value = true
  previewIndex.value = data.index
}
const handleClose = (data: boolean) => {
  console.log(data)
  previewShow.value = false
}
// 首页接口
const bannerList = ref([] as CommunityBanners[])
const boardsData = ref({} as ColumnBoardPage)
const topData = ref<TopContent[]>([])

const fetchData = async (type?: number, isLoading?: boolean) => {
  const { code, data } = await getCommunityHomeData({
    boardSize: 18,
    topContentSize: 5,
    topType: 1,
    loadingShow: isLoading ? '0' : '1'
  })
  if (code === 1) {
    refreshing.value = false
    bannerList.value = data.banners
    boardsData.value = data.columnBoardPage
    topData.value = data.topContents
    if (type !== 1) {
      articleData.value = data.contents.records
      finished.value = false
    }
  }
}
onMounted(() => {
  fetchData()
})
const route = useRoute()
// const getDetail = async (id: string, index: number) => {
//   const res = await getCommunityBoardContent({ id })
//   if (res && res.data) {
//     articleData.value[index] = res.data
//   }
// }
const getDetail = async (detailId: string, index: number) => {
  const currentPage = Math.ceil((index + 1) / pageSize.value)
  const { code, data } = await getCommunityBoardContentList({
    current: currentPage,
    size: pageSize.value,
    sortType: sortType.value,
    ...(activeType.value && {
      type: activeType.value
    }),
    loadingShow: '0'
  })
  if (code === 1) {
    const hasId = data.records.some((item) => item.id === detailId)
    if (hasId) {
      articleData.value[index] = data.records.filter((item) => item.id === detailId)[0]
    } else {
      const index = articleData.value.findIndex((item) => item.id === detailId)
      if (index !== -1) {
        articleData.value.splice(index, 1)
      }
    }
  }
}
watch(
  () => route.fullPath,
  (newVal, oldPath) => {
    if (oldPath?.includes('comDetailLevel') || oldPath?.includes('rollVideo')) {
      const matchResult = oldPath.match(/id=([\d]+)/)
      if (matchResult) {
        const id = matchResult[1]
        const index = articleData.value.findIndex((item) => item.id === id)
        if (index <= -1) {
          return
        }
        getDetail(id, index)
      }
    }
    if (oldPath && oldPath.includes('communityPublish')) {
      onRefresh(true)
    }
  },
  { immediate: true, deep: true }
)
onActivated(async () => {
  fetchData(1, true)
  current.value = 1
  finished.value = false
  await onLoad()
})

const handleActive = (value: number) => {
  current.value = 1
  // articleData.value = []
  activeType.value = value
  // finished.value = true
  // listLoading.value = false
  onLoad()
}
</script>

<style lang="less" scoped>
.community-page {
  padding-top: 44px;

  :deep(.van-nav-bar) {
    z-index: 100;
  }

  .iconfont {
    font-size: 20px;
    color: #171921;
  }

  .content {
    background: #f4f5f7;
    padding: 0 16px;

    .carousel {
      width: 100%;
      height: 140px;
      background: red;
      border-radius: 8px;
    }
  }
}
</style>
